import * as React from "react";
function Icon() {
    return (
       <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
           <rect x="0.722656" width="22.7992" height="22.8" rx="11.3996" fill="#838280" fillOpacity="0.1"/>
           <path d="M9.85094 16.1801V10.9221M7.46094 11.8781V15.2241C7.46094 15.7521 7.88895 16.1801 8.41694 16.1801H14.8347C15.5425 16.1801 16.1444 15.6637 16.252 14.9642L16.7668 11.6182C16.9004 10.7495 16.2283 9.96612 15.3495 9.96612H13.6749C13.4109 9.96612 13.1969 9.75211 13.1969 9.48812V7.79879C13.1969 7.14783 12.6692 6.62012 12.0183 6.62012C11.863 6.62012 11.7223 6.71156 11.6592 6.85344L9.9771 10.6383C9.90038 10.8109 9.7292 10.9221 9.5403 10.9221H8.41694C7.88895 10.9221 7.46094 11.3501 7.46094 11.8781Z" stroke="#EB3D00" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
       </svg>
    );
}

export default Icon;
